import * as angular from 'angular';
import { UtilService } from 'app/_services/util.service';

class DateToTimeStringConverter implements ng.IDirective {
    public restrict = 'A';
    public scope = false;
    public require = 'ngModel';

    constructor(
        private utilService: UtilService,
        private moment: moment.MomentStatic
    ) {}

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: angular.INgModelController
    ) => {
        ngModelCtrl.$formatters.push((modelValue: Date): string => {
            if (!modelValue || isNaN(modelValue.valueOf())) return null;
            let viewValue: string = `${this.utilService.padLeadingZero(
                modelValue.getHours()
            )}:${this.utilService.padLeadingZero(modelValue.getMinutes())}`;
            viewValue =
                viewValue.indexOf(':') === -1 ? viewValue + ':00' : viewValue;
            return viewValue;
        });

        ngModelCtrl.$parsers.push((viewValue: string): Date => {
            if (!viewValue) return null;

            try {
                const splitViewValue: string[] = viewValue.split(':');
                const minutes: number = parseInt(splitViewValue[1]);
                const hours: number = parseInt(splitViewValue[0]);

                if (hours > 23 || hours < 0 || minutes > 59 || minutes < 0) {
                    return undefined;
                }

                const date = new Date();
                date.setHours(hours);
                date.setMinutes(isNaN(minutes) ? 0 : minutes);

                return date;
            } catch (e) {
                return undefined;
            }
        });

        elem.bind('blur', () => {
            if (!ngModelCtrl.$valid) {
                return;
            }

            let viewValue: string | Date = ngModelCtrl.$modelValue;

            let i;
            for (i = ngModelCtrl.$formatters.length - 1; i >= 0; i--) {
                viewValue = ngModelCtrl.$formatters[i](viewValue);
            }

            ngModelCtrl.$viewValue = viewValue;
            ngModelCtrl.$render();
        });
    };
}

DateToTimeStringConverter.$inject = ['utilService', 'moment'];

angular
    .module('app')
    .directive(
        'pkpDateToTimeStringConverter',
        (utilService, moment) =>
            new DateToTimeStringConverter(utilService, moment)
    );
